<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addShift"
            >添加班次</el-button
          >
        </div>
      </div>
      <div class="tab-content">
        <div class="list" v-loading="isListLoad">
          <el-table :data="shiftList" style="width: 100%;">
            <el-table-column label="班次名称">
              <template slot-scope="scope">
                <div class="name">
                  {{ scope.row.schedueName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="班次时间">
              <template slot-scope="scope">
                <div class="item-count">
                  {{ scope.row.startTime }}-{{ scope.row.endTime }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="使用人数">
              <template slot-scope="scope">
                <div class="item-count">{{ scope.row.peopleNum }}人</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="right">
              <template slot-scope="scope">
                <div class="float-right">
                  <el-button
                    size="small"
                    type="primary"
                    @click="edit(scope.$index)"
                    plain
                    >编辑</el-button
                  >
                  <el-button
                    size="small"
                    type="danger"
                    @click="del(scope.row.id)"
                    plain
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            background
            layout="prev, pager, next, jumper"
            :total="count"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogAddShiftVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
      @close="addShiftDialogClose"
    >
      <div slot="title" class="dialog-title">
        {{ addShiftForm.schedulingId ? "编辑班次" : "添加班次" }}
      </div>
      <el-form
        :model="addShiftForm"
        :rules="addShiftFormRule"
        ref="addShiftForm"
        label-width="108px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="班次名称" prop="schedueName">
          <div class="form-flex">
            <el-input
              v-model="addShiftForm.schedueName"
              placeholder="请填写班次名称"
              size="small"
            ></el-input>
            <p>{{ addShiftForm.startTime }} - {{ addShiftForm.endTime }}</p>
          </div>
        </el-form-item>
        <el-form-item label="班次时间"
          ><el-select
            v-model="addShiftForm.startTime"
            placeholder="请选择开始时间"
            size="small"
            @change="onStartTimeChanged"
          >
            <el-option
              v-for="(item, index) in beginTimeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option> </el-select
          >&nbsp;&nbsp;-&nbsp;&nbsp;<el-select
            v-model="addShiftForm.endTime"
            placeholder="请选择开始时间"
            size="small"
          >
            <el-option
              v-for="(item, index) in endTimeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save" :loading="isSubmit">
          {{ addShiftForm.schedulingId ? "编辑" : "添加" }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  schedulingList,
  findSchedulingListNum,
  saveOrUpdateScheduling,
  deleteScheduling,
} from "@/api/index.js";
export default {
  data() {
    return {
      shiftList: [],
      count: 0,
      pageNo: 1,
      pageSize: 5,
      dialogAddShiftVisible: false,
      addShiftForm: {
        schedueName: "",
        startTime: "10:00",
        endTime: "22:00",
      },
      oldStartTime: "10:00",
      addShiftFormRule: {
        schedueName: [
          {
            required: true,
            message: "请填写班次名称",
            trigger: "blur",
          },
        ],
      },
      isListLoad: false,
      isSubmit: false,
    };
  },
  computed: {
    beginTimeList() {
      let beginTime = new Date(`${new Date().pattern("yyyy-MM-dd")} 00:00`);
      let endTime = new Date(+beginTime + 24 * 60 * 60 * 1000);
      let timeStep = 30 * 60 * 1000;
      let stepNum = (endTime - beginTime) / timeStep;
      let timeList = [];
      let i = 0;
      while (i < stepNum) {
        let stepTime = new Date(beginTime);
        timeList.push({
          value: stepTime.pattern("HH:mm"),
          label: stepTime.pattern("HH:mm"),
        });
        i++;
        beginTime = +beginTime + timeStep;
      }
      return timeList;
    },
    endTimeList() {
      let beginTime = new Date(
        `${new Date().pattern("yyyy-MM-dd")} ${this.addShiftForm.startTime}`
      );
      let endTime = new Date(+beginTime + 24 * 60 * 60 * 1000);
      let timeStep = 30 * 60 * 1000;
      let stepNum = (endTime - beginTime) / timeStep;
      let currentDay = beginTime.getDate();
      let timeList = [];
      let i = 0;
      let limitTime = new Date(
        `${new Date(endTime).pattern("yyyy-MM-dd")} 12:00`
      );
      while (i < stepNum) {
        beginTime = +beginTime + timeStep;
        if (+beginTime > +limitTime) break;
        let stepTime = new Date(beginTime);
        timeList.push({
          value: `${
            stepTime.getDate() > currentDay ? "[次日]" : ""
          }${stepTime.pattern("HH:mm")}`,
          label: `${
            stepTime.getDate() > currentDay ? "[次日]" : ""
          }${stepTime.pattern("HH:mm")}`,
        });
        i++;
      }
      return timeList;
    },
  },
  watch: {},
  mounted() {
    this.getPageData();
  },
  methods: {
    onStartTimeChanged(value) {
      let endTime = this.addShiftForm.endTime.split("]");
      if (endTime.length == 2) {
        endTime = new Date(
          `${new Date(+new Date() + 24 * 60 * 60 * 1000).pattern(
            "yyyy-MM-dd"
          )} ${endTime[1].trim()}`
        );
      } else {
        endTime = new Date(
          `${new Date().pattern("yyyy-MM-dd")} ${endTime[0].trim()}`
        );
      }
      let startTime = new Date(`${new Date().pattern("yyyy-MM-dd")} ${value}`);
      console.log("onStartTimeChanged", +endTime, +startTime);
      if (+startTime >= +endTime) {
        this.$message.error("开始时间必须小于结束时间");
        this.addShiftForm.startTime = this.oldStartTime;
        return;
      }
      if (+endTime - +startTime > 24 * 60 * 60 * 1000) {
        this.$message.error("班次时间不能超过24小时");
        this.addShiftForm.startTime = this.oldStartTime;
        return;
      }
      this.oldStartTime = value;
    },
    getPageData() {
      this.schedulingList();
      this.findSchedulingListNum();
    },
    addShift() {
      this.dialogAddShiftVisible = true;
    },
    handleSizeChange(e) {
      console.log(e);
    },
    handleCurrentChange(e) {
      this.pageNo = e;
      this.schedulingList();
    },
    schedulingList() {
      this.isListLoad = true;
      schedulingList({
        pageNo: this.pageNo,
        row: this.pageSize,
      }).then((res) => {
        if (res.code == 1) {
          this.shiftList = res.data;
        }
        if (res.code == -1) {
          this.shiftList = [];
        }
        this.isListLoad = false;
      });
    },
    findSchedulingListNum() {
      findSchedulingListNum().then((res) => {
        if (res.code == 1) {
          this.count = res.data;
        }
      });
    },
    del(id) {
      this.$msgbox({
        title: "消息",
        message: `是否删除，删除后将无法恢复！`,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            deleteScheduling({
              schedulingId: id,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "删除成功",
                  type: "success",
                });
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
            done();
          } else {
            done();
          }
        },
      }).then((action) => {});
    },
    edit(index) {
      this.addShiftForm = JSON.parse(JSON.stringify(this.shiftList[index]));
      this.oldStartTime = this.addShiftForm.startTime;
      this.addShiftForm.schedulingId = this.addShiftForm.id;
      this.dialogAddShiftVisible = true;
    },
    save() {
      this.$refs.addShiftForm.validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          let param = this.addShiftForm;
          saveOrUpdateScheduling(param).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: param.schedulingId ? "编辑成功" : "创建成功",
                type: "success",
                duration: 2000,
              });
              this.getPageData();
              this.dialogAddShiftVisible = false;
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
            setTimeout(() => {
              this.isSubmit = false;
            }, 500);
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    linkTo(path) {
      this.$router.push({
        path: path,
      });
    },
    addShiftDialogClose() {
      this.addShiftForm = {
        schedueName: "",
        startTime: "10:00",
        endTime: "22:00",
      };
    },
    autoPrintChange(val) {
      if (!val) {
        this.addShiftForm.printPageNum = 1;
      }
    },
    printStageChange(val) {
      if (val == 1) {
        this.addShiftForm.printStep = 2;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-content {
    display: block;
    padding: 20px;
  }
  .el-dialog {
    .el-select {
      width: 160px;
    }
    .form-flex {
      display: flex;
      padding-right: 50px;
      .el-input {
        width: 140px;
        margin-right: 20px;
      }
    }
    .dialog-title {
      font-weight: bold;
    }
    .ruleForm-bottom {
      margin-top: 20px;
    }
  }
}
</style>
